import React from 'react';
import PropTypes from 'prop-types';
import { LineItemDataProvider } from '../../contexts/LineItemDataProvider';
import { DetailsLineItemDisplay } from './DetailsLineItemDisplay';

/**
 * An OD Line Item Component Wrapper that sets up the LineItemDataProvider.
 *
 * Allows for all children of this component to use the `useLineItemData` hook for consistent
 * data access to line item data.
 *
 */
export const OrderDetailsLineItem = ({ item, orderNumber }) => (
  <LineItemDataProvider item={item} orderNumber={orderNumber}>
    <DetailsLineItemDisplay />
  </LineItemDataProvider>
);

OrderDetailsLineItem.propTypes = {
  item: PropTypes.object,
  orderNumber: PropTypes.string.isRequired,
};
